import { MainContainer } from './Main.styled';
import { IChildren } from '../../../../interfaces/common/common';
import React from 'react';

export const Main: React.FC<IChildren> = ({ children }) => {
  return (<MainContainer>{children}</MainContainer>);
};
